import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTachometer, faImage, faArrowLeft, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState } from 'recoil';
import Select from 'react-select'

import { topAlertMessageState, topAlertStatusState } from "../../AppState";
import { postCMSImageCreateAPI } from "../../API/CMSImage";
import FormErrorBox from "../Reusable/FormErrorBox";
import FormInputField from "../Reusable/FormInputField";
import FormTextareaField from "../Reusable/FormTextareaField";
import FormMultiSelectField from "../Reusable/FormMultiSelectField";
import FormRadioField from "../Reusable/FormRadioField";
import PageLoadingContent from "../Reusable/PageLoadingContent";


function ImageAdd() {
    ////
    ////
    ////

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [isFetching, setFetching] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    ////
    //// Event handling.
    ////

    const onHandleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const onNameChange = (e) => {
        setName(e.target.value);
    }

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Starting...")
        setFetching(true);

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('name', name);
        formData.append('description', description);

        postCMSImageCreateAPI(
            formData,
            onCMSImageCreateSuccess,
            onCMSImageCreateError,
            onCMSImageCreateDone
        );
        console.log("onSubmitClick: Finished.")
    }

    ////
    //// API.
    ////

    function onCMSImageCreateSuccess(response){
        // For debugging purposes only.
        console.log("onCMSImageCreateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("CMSImage created");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onCMSImageCreateSuccess: Delayed for 2 seconds.");
            console.log("onCMSImageCreateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Redirect the user to a new page.
        setForceURL("/cms-image/"+response.id);
    }

    function onCMSImageCreateError(apiErr) {
        console.log("onCMSImageCreateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onCMSImageCreateError: Delayed for 2 seconds.");
            console.log("onCMSImageCreateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onCMSImageCreateDone() {
        console.log("onCMSImageCreateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
        }

        return () => { mounted = false; }
    }, []);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/cms-images" aria-current="page"><FontAwesomeIcon className="fas" icon={faImage} />&nbsp;Images</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;Add</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/cms-images`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Images</Link></li>
                        </ul>
                    </nav>

                    {/* Page */}
                    <nav class="box">
                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faImage} />&nbsp;Images</p>
                        {isFetching
                            ?
                                <PageLoadingContent displayMessage={"Loading..."} />
                            :
                            <>
                                <FormErrorBox errors={errors} />

                                <p class="subtitle is-6">Add a new Image</p>
                                <div class="container">
                                    <FormInputField
                                        label="Name"
                                        name="name"
                                        placeholder="Text input"
                                        value={name}
                                        errorText={errors && errors.name}
                                        helpText=""
                                        onChange={onNameChange}
                                        isRequired={true}
                                        maxWidth="150px"
                                    />

                                    <FormInputField
                                        label="Description"
                                        name="description"
                                        type="text"
                                        placeholder="Text input"
                                        value={description}
                                        errorText={errors && errors.description}
                                        helpText=""
                                        onChange={onDescriptionChange}
                                        isRequired={true}
                                        maxWidth="485px"
                                    />

                                    <input type="file" onChange={onHandleFileChange} />
                                    <br />
                                    <br />

                                    <div class="columns">
                                        <div class="column is-half">
                                            <Link to={`/cms-images`} class="button is-hidden-touch"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                            <Link to={`/cms-images`} class="button is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                        </div>
                                        <div class="column is-half has-text-right">
                                            <button class="button is-primary is-hidden-touch" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                            <button class="button is-primary is-fullwidth is-hidden-desktop" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                        </div>
                                    </div>

                                </div>
                            </>
                        }
                    </nav>
                </section>
            </div>
        </>
    );
}

export default ImageAdd;
